import { render, staticRenderFns } from "./WattChart2.vue?vue&type=template&id=18bb4796&scoped=true"
import script from "./WattChart2.vue?vue&type=script&lang=js"
export * from "./WattChart2.vue?vue&type=script&lang=js"
import style0 from "./WattChart2.vue?vue&type=style&index=0&id=18bb4796&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bb4796",
  null
  
)

export default component.exports